"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAppLink = getAppLink;
exports.gotoApp = gotoApp;
exports.openAppByProtocol = openAppByProtocol;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _qs = _interopRequireDefault(require("qs"));

var _url = require("../url");

var _mobile = require("./mobile");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUniversalLinkSupported() {
  if (!(0, _mobile.isIOS)()) {
    return false;
  }

  var iOSVersion = (0, _mobile.getIOSVersion)(); // 到目前为止 iOS 的主版本号是符合格式的，未来的 iOS 版本中有可能出现不符合格式的版本号，
  // 除非苹果在未来某个版本中废除了该特性，新版应该是支持 Universal Link 的。

  if (!iOSVersion) {
    return true;
  } // WORKAROUND: iOS 10 无法使用 Universal Link 调起，原因不明，已缺乏客户端支持


  if (iOSVersion.major <= 10) {
    return false;
  }

  return true;
}

/**
 * 获取 target 对应的 msr0 链接与 Universal Link 链接，检查环境是否支持 Universal Link 唤起。
 * 当 type 为 'webview' 时，path 应为要打开页面的 URL，函数会自动 encode 并拼接协议链接。
 * @param target 跳转目标
 * @returns msr0 链接、 Universal Link 链接与是否支持 Universal Link 唤起
 * @examples
 *  getAppLink({ type: 'homepage' }) => missevan://homepage
 *  getAppLink({ type: 'user', path: 'center' }) => missevan://user/center
 *  getAppLink({ type: 'user', path: 'center', options:  { a: 1 }}) => missevan://user/center?a=1
 *  getAppLink({ type: 'webview', path: 'https://www.missevan.com' }) => missevan://webview/https%3A%2F%2Fwww.missevan.com
 *  getAppLink({ type: 'webview', path: 'https://www.missevan.com?a=1' }) => missevan://webview/https%3A%2F%2Fwww.missevan.com%3Fa%3D1
 *  getAppLink({ type: 'webview', path: 'https://www.missevan.com?a=1', options: { a: 1 } }) missevan://webview/https%3A%2F%2Fwww.missevan.com%3Fa%3D1?a=1
 */
function getAppLink(target) {
  var _context4, _context5, _context6, _context7;

  var type = target.type,
      path = target.path,
      options = target.options;

  if (type === 'webview' && path) {
    var _context, _context2, _context3;

    var _msrPath = (0, _concat.default)(_context = "webview/".concat(encodeURIComponent(path))).call(_context, _qs.default.stringify(options, {
      addQueryPrefix: true
    }));

    return {
      url: (0, _concat.default)(_context2 = "".concat(_url.MISSEVAN_APP_SCHEME_PREFIX, "/")).call(_context2, _msrPath),
      universalLink: (0, _concat.default)(_context3 = "".concat(_url.MISSEVAN_APP_PREFIX_URL, "/open/")).call(_context3, _msrPath),
      isUniversalLinkSupported: isUniversalLinkSupported()
    };
  }

  var msrPath = (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "".concat(type)).call(_context5, path ? "/".concat(path) : '')).call(_context4, _qs.default.stringify(options, {
    addQueryPrefix: true
  }));
  return {
    url: (0, _concat.default)(_context6 = "".concat(_url.MISSEVAN_APP_SCHEME_PREFIX, "/")).call(_context6, msrPath),
    universalLink: (0, _concat.default)(_context7 = "".concat(_url.MISSEVAN_APP_PREFIX_URL, "/open/")).call(_context7, msrPath),
    isUniversalLinkSupported: isUniversalLinkSupported()
  };
}
/**
 * 跳转到 target 对应的**msr0链接**，应该仅在客户端内使用。
 *
 * @param target 跳转目标
 */


function gotoApp(target) {
  window.location.href = getAppLink(target).url;
}

function openAppByProtocol(id, type, opts) {
  var _getAppLink = getAppLink({
    type: type,
    path: id,
    options: opts
  }),
      url = _getAppLink.url,
      universalLink = _getAppLink.universalLink,
      universalLinkSupported = _getAppLink.isUniversalLinkSupported; // 低版本 iOS 不支持 Universal Links 唤起


  if ((0, _mobile.isIOS)() && universalLinkSupported) {
    if ((0, _mobile.isWeixinBrowser)() || (0, _mobile.isQQWebview)() || (0, _mobile.isWeiboBrowser)()) {
      /**
       * 延迟一秒重新刷新页面是因为在微信内如果打开了 universal link，虽然页面不变，
       * 但是分享到朋友圈会直接是 universal link 的链接。
       * 这里用这个方法绕过。
       */
      var oldUrl = window.location.href;
      window.setTimeout(function () {
        window.location.replace(oldUrl);
      }, 1000);
    }
    /**
     * 针对 iOS 设备 QQ 内置浏览器下不能正常唤起 APP 的兼容处理
     */


    if ((0, _mobile.isQQWebview)()) {
      var link = document.createElement('a');
      link.setAttribute('href', url);
      link.style.display = 'none';
      document.body.appendChild(link);
      var event = document.createEvent('HTMLEvents');
      event.initEvent('click', false, false);
      link.dispatchEvent(event);
    }

    window.location.href = universalLink;
  } else {
    window.location.href = url;
  }
}